import "./App.css";
import Row from "./Row";
import requests from "./requests";
import Banner from "./Banner";
import Nav from "./Nav";
function App() {
  return (
    <div className="App">
      <Nav />
      <Banner />
      <Row
        title="RUSHFLIX ORIGINALS"
        Url={requests.fetchNetflixOriginals}
        isLargerRow
      />
      <Row title="Trending" Url={requests.fetchTrending} />
      <Row title="Action Movies" Url={requests.fetchActionMovies} />
      <Row title="Comedy Movies" Url={requests.fetchComedyMovies} />
      <Row title="Horror Movies" Url={requests.fetchHorrorMovies} />
      <Row title="Romance Movies" Url={requests.fetchRomanceMovies} />
      <Row title="Documentaries" Url={requests.fetchDocumentaries} />
    </div>
  );
}

export default App;
